import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MgIcons } from '@app/src/app/icon/mg-icons.types';

@Component({
  selector: 'mg-tt-dropdown-btn',
  templateUrl: './tt-dropdown-btn.component.html',
  styleUrls: ['./tt-dropdown-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TtDropdownButtonComponent {
  @Input() icon: MgIcons;
  @Input() expanded = false;
  @Input() dropdown = true;
}
